import Vue from 'vue';
import router from '@/router';
import vueAnalytics from 'vue-analytics';

Vue.use(vueAnalytics, {
  id: 'UA-159051013-1',
  require: 'linkid',
  router
});
